import React from 'react';
import { useNavigate } from 'react-router-dom';
import {ButtonNextStep, ButtonPrevStep} from '../../../../../components/buttons/ButtonNavigation';
import CenterPhotoPicker from '../../../../../components/PhotoPicker/SubComponent/CenterPhotoPicker';
import { IconLogoIEntry } from '../../../../../components/buttons/IconButtons';
import {Box} from '@mui/material';
import ButtonSubAction from '../../../../../components/buttons/ButtonSubAction';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const BodyValidation = (
    {
        children,
        click = null,
        url = '',
        clickPrev = null,
        clickHref = null,
        showBtnNext=true,
        showBtnPrev = false,
        btnDisabled = false, // btnDisabled Next
        textFooter = "",
        showLogoFooter=true,
        className="identity-validation-external-body",
        classWith="content-center-w-600px gap-4",
        textBtnNext="next"
    }
) => {

    const navigate = useNavigate();

    const handleClickNext = (click, url) => {
        if (click != null) click();
        if (url !== '') navigate(url);
    }

    return (
        <div className={`${className}`}>

            <CenterPhotoPicker classWith={`${classWith}`}>

                {children}


                { (showBtnPrev || showBtnNext ) &&
                    <div className="d-flex justify-content-center align-items-center w-100 gap-1">
                        {showBtnPrev && (
                            <Box className={`p-0  ${showBtnNext ? "col-sm-6" : "col-sm-12"}`}>
                                <ButtonPrevStep
                                    id="btn_cm_cancel"
                                    text={"dismiss"}
                                    classNameBtn="btn-background-transparent-shades-100"
                                    click={() => {
                                        if(clickPrev != null) clickPrev();
                                    }}
                                />
                            </Box>
                        )}
                        {showBtnNext && (
                            <Box className={`p-0 ${!showBtnPrev && showBtnNext ? 'col-sm-12' :  showBtnNext ? "col-sm-6" : "col-sm-12"}`}>
                                <ButtonNextStep
                                    id="btn_cm_confirm"
                                    text={textBtnNext}
                                    click={() => {
                                        handleClickNext(click, url);
                                    }}
                                    disabled={btnDisabled}
                                />
                            </Box>
                        )}
                    </div>
                }


                {textFooter !== "" &&
                    <ButtonSubAction
                        className={"btn-href-secondary-500"}
                        name={textFooter}
                        onClick={(e) => {
                            e.preventDefault();
                            if (clickHref != null) {
                                clickHref();
                            }
                        }}
                    />
                }

            </CenterPhotoPicker>

            {showLogoFooter &&
                <div className="d-none d-md-flex justify-content-center">
                    <IconLogoIEntry />
                </div>
            }


        </div>
    )
}

export default BodyValidation
